import { render, staticRenderFns } from "./RiskClassification.vue?vue&type=template&id=29b69332&"
import script from "./RiskClassification.vue?vue&type=script&lang=js&"
export * from "./RiskClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports